import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

/**
 * A related record that was linked to / unlinked from the event's subject.
 */
export class ActivityChangedLinksDto {
  targetSubject!: AppSubjectEnum;
  targetId!: number;
  targetLabel?: string;
}
